module.exports = __webpack_public_path__ + "img/199.problem_broken_door.6ccf5f01.svg";